<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="produtoForm" *ngIf="produtoForm">
      <!-- Seção de Lista de Preço, Tabela de Preço e Botão Adicionar -->
      <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="8px" class="form-section">
        <!-- Lista de Preço -->
        <div fxFlex="100" fxFlex.gt-sm="35" fxFlex.sm="30" fxFlex.lt-md="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Lista de Preço:</mat-label>
            <mat-select [formControl]="produtoForm?.controls['lista']!" (selectionChange)="this.changeLista()">
              <mat-option *ngFor="let lista of listaPrecos" [value]="lista">
                {{lista.id.toString().padStart(5,'0') + " - " + lista.descricao}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Tabela de Preço -->
        <div fxFlex="100" fxFlex.gt-sm="35" fxFlex.sm="30" fxFlex.lt-md="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Tabela de Preço:</mat-label>
            <mat-select [formControl]="produtoForm?.controls['tabela']!">
              <mat-option *ngFor="let tabela of tabelas$ | async" [value]="tabela">
                {{tabela.id.tabelaId.toString().padStart(5,'0') + " - " + tabela.descricao}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Botão Adicionar -->
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20" fxFlex.lt-md="100" class="button-container" style="height: 60px;">
          <button mat-raised-button color="primary" (click)="incluirPreco(novoPreco)" class="full-width-button">
            <mat-icon>add_circle</mat-icon> Adicionar
          </button>
        </div>
      </div>

      <!-- Seção de Cards de Preços -->
      <div fxLayout="row wrap" fxLayoutGap="16px" class="precos-section">
        <div *ngFor="let preco of precos$ | async" fxFlex="100" fxFlex.gt-sm="48" fxFlex.sm="100" fxFlex.lt-md="100">
          <mat-card class="user-card">
            <mat-card-title>
              <div class="card-title-text">
                {{ preco?.listaPreco.id.toString().padStart(5,'0') + " - " + preco?.listaPreco?.descricao }}
                <span fxFlex></span>
                <button mat-icon-button [matMenuTriggerFor]="userMenu" (click)="$event.preventDefault()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #userMenu="matMenu">
                  <button mat-menu-item class="mr-1" alt="Editar Preço" (click)="openProdutoPrecoPopUp(preco);$event.preventDefault();">
                    <mat-icon color="primary">edit</mat-icon>Editar
                  </button>
                  <button mat-menu-item alt="Deletar Preço" (click)="$event.preventDefault();deletePreco(preco)">
                    <mat-icon color="warn">delete</mat-icon>Deletar
                  </button>
                </mat-menu>
              </div>
              <mat-divider></mat-divider>
            </mat-card-title>
            <mat-card-content>
              <div class="user-details">
                <table class="mat-table" style="text-align: left;">
                  <tr class="mat-row">
                    <td class="mat-cell">Tabela:</td>
                    <td class="mat-cell">
                      {{ preco?.tabela?.id.tabelaId.toString().padStart(5,'0') + " - " + preco?.tabela?.descricao }}
                    </td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell">Preço:</td>
                    <td class="mat-cell">
                      <ng-container *ngIf="!preco?.preco">{{0 | currency:'BRL'}}</ng-container>
                      <ng-container *ngIf="preco?.preco">{{preco?.preco | currency:'BRL'}}</ng-container>
                    </td>
                  </tr>
                </table>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon>{{ "CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>